import { NumberFormatValues } from "@common/schemas/domains/reportSettings/number-format-setting.schema";
import { formatMoneyColumnHeader } from "@common/helpers/number";
import {
    SCHEDULES_ROLLFORWARD_COLUMNS,
    SCHEDULES_ROLLFORWARD_COLUMN_LABELS,
} from "@common/types/reports/schedules-report";
import { PreviewSchedulesDataset } from "./previewTypes";
import { previewRowPercent } from "./previewPercent";
import { AmountCell } from "./AmountCell";
import { PercentCell } from "./PercentCell";
import styles from "./ReportPreview.module.scss";

interface Props {
    dataset: PreviewSchedulesDataset;
    numberFormat: NumberFormatValues;
}

export const SchedulesTable = ({ dataset, numberFormat }: Props) => (
    <div className={styles.table}>
        <div className={styles.columnHeader} data-columns="schedules">
            <span>{dataset.scheduleHeader}</span>
            {SCHEDULES_ROLLFORWARD_COLUMNS.map((column) => (
                <span key={column} className={styles.amountCell}>
                    {formatMoneyColumnHeader(
                        SCHEDULES_ROLLFORWARD_COLUMN_LABELS[column],
                        numberFormat,
                    )}
                </span>
            ))}
            <span className={styles.percentCell}>{dataset.percentHeader}</span>
        </div>
        {dataset.rows.map((row) => (
            <div
                key={row.id}
                className={styles.gridRow}
                data-columns="schedules"
                data-kind={row.kind}
                data-top-border={row.hasTopBorder || undefined}
            >
                <span data-depth={row.depth}>{row.label}</span>
                {SCHEDULES_ROLLFORWARD_COLUMNS.map((column) => (
                    <AmountCell
                        key={column}
                        value={row.cells[column]}
                        numberFormat={numberFormat}
                    />
                ))}
                <PercentCell
                    value={previewRowPercent({
                        amount: row.cells.ending,
                        percentBase: dataset.percentBase,
                    })}
                    numberFormat={numberFormat}
                />
            </div>
        ))}
    </div>
);
